
import { uploadsApi } from "../../apis";
import Swal from "sweetalert2";




export const descargarAndGuardarCarrito = async (datos) => {
    try {
        const { data } = await uploadsApi.post('/generar/coticarrito', datos, {responseType: 'arraybuffer'});
        return data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const descargarSoloCotizacion = async (id) => {
    try {
        const { data } = await uploadsApi.get(`/solo/descargar/${id}`, {responseType: 'arraybuffer'});
        return data;
    } catch (error) {
        console.log(error)
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}





export const descargarReciboOP = async (id) => {
    try {
        const { data } = await uploadsApi.get(`/descargar/op/${id}`, {responseType: 'arraybuffer'});
        return data;
    } catch (error) {
        console.log(error)
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



